import * as actionTypes from './ActionTypes';
import { setDefaultReducer } from '../helpers/Reducer';

export const setProfile = setDefaultReducer(actionTypes.SET_PROFILE);